import {Component, Input, OnInit} from '@angular/core';
import {TipoDocumentoDTO} from '../../../models/dtos/TipoDocumentoDTO';
import {PaisDTO} from '../../../models/dtos/PaisDTO';
import {ReceptorCFEDTO} from '../../../models/dtos/ReceptorCFEDTO';
import {AbstractControl, FormControl, FormGroup} from '@angular/forms';
import {DatosInicioReceptorDTO} from '../../../models/dtos/datosInicio/DatosInicioReceptorDTO';
import {Utils} from '../../utils/utils';
import {
  COD_TIPO_DOC_CI,
  COD_TIPO_DOC_DNI,
  COD_TIPO_DOC_OTROS,
  COD_TIPO_DOC_RUT
} from '../../../constants/ConstantesTipoDocumento';
import {
  COD_PAIS_ARG,
  COD_PAIS_BR, COD_PAIS_CL,
  COD_PAIS_MX,
  COD_PAIS_PE,
  COD_PAIS_PY,
  COD_PAIS_URU,
  COD_PAIS_US
} from '../../../constants/ConstantesPais';
import { startWith, map } from 'rxjs/operators';
import {Observable} from 'rxjs';

@Component
({
  selector: 'app-receptor',
  templateUrl: './receptor.component.html',
  styleUrls: ['./receptor.component.scss']
})
export class ReceptorComponent implements OnInit
{
  @Input()
  receptorCFEDTO: ReceptorCFEDTO;

  @Input()
  datosInicioReceptorDTO: DatosInicioReceptorDTO;

  @Input()
  parentFormGroup: FormGroup;

  @Input()
  esAgregarReceptor: boolean;

  @Input()
  esEResguardo: boolean = false;

  tiposDocumentosBackupDTOs: Array<TipoDocumentoDTO>;
  paisesBackupDTOs: Array<PaisDTO>;

  filteredReceptores: Observable<string[]>;
  filteredRazonesSociales: Observable<string[]>;

  constructor()
  {

  }

  ngOnInit()
  {
    this.tiposDocumentosBackupDTOs = Object.assign([], this.datosInicioReceptorDTO.tiposDocumentosDTOs);
    this.paisesBackupDTOs = Object.assign([], this.datosInicioReceptorDTO.paisesDTOs);

    this.filteredReceptores = this.documentoReceptorControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filter(value))
      );

    this.filteredRazonesSociales = this.razonSocialReceptorControl.valueChanges
      .pipe(
        startWith(''),
        map(value => this._filterRazonesSociales(value))
      );
  }

  input() {
    const doc = this.receptorCFEDTO.documento;
    if (this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado === 2 && this.datosInicioReceptorDTO.codigoPaisSeleccionado === 'UY' && doc.length !== 12) {
      this.parentFormGroup.get('documentoReceptorControl').setErrors({ rutError: true });
    }
    if (this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado === 3 && this.datosInicioReceptorDTO.codigoPaisSeleccionado === 'UY' && !this.functionCedula(doc)) {
      this.parentFormGroup.get('documentoReceptorControl').setErrors({ ciError: true });
    }
    if (this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado === 6 && this.datosInicioReceptorDTO.codigoPaisSeleccionado === 'AR' && (doc.length < 7 || doc.length > 8)) {
      this.parentFormGroup.get('documentoReceptorControl').setErrors({ dniError: true });
    }
    if (this.receptorCFEDTO.documento.length === 0) {
      this.parentFormGroup.get('documentoReceptorControl').setErrors({ required: true });
    }
  }

  get errorMessage(): string {
    const form: FormControl = (this.parentFormGroup.get('documentoReceptorControl') as FormControl);
    return form.hasError('required') ?
      'El documento es requerido.' :
      form.hasError('rutError') ?
        'Documento inválido.' :
        form.hasError('ciError') ?
          'Documento inválido.' :
          form.hasError('dniError') ?
            'Documento inválido.' : '';
  }

  get tipoDocumentoReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('tipoDocumentoReceptorControl');
  }

  get paisReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('paisReceptorControl');
  }

  get documentoReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('documentoReceptorControl');
  }

  get razonSocialReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('razonSocialReceptorControl');
  }

  get direccionReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('direccionReceptorControl');
  }

  get ciudadReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('ciudadReceptorControl');
  }

  get departamentoReceptorControl(): AbstractControl
  {
    return this.parentFormGroup.get('departamentoReceptorControl');
  }

  public hayControlError(control: AbstractControl): boolean
  {
    return (control.invalid && (control.dirty || control.touched) && control.errors.required);
  }

  private obtenerTipoDocumento(codigoTipoDocumento: number): TipoDocumentoDTO
  {
    let tipoDocumentoARetornarDTO: TipoDocumentoDTO = null;
    for (const tipoDocumentoDTO of this.tiposDocumentosBackupDTOs)
    {
      if (tipoDocumentoDTO.codigo === codigoTipoDocumento)
      {
        tipoDocumentoARetornarDTO = tipoDocumentoDTO;
        break;
      }
    }

    return tipoDocumentoARetornarDTO;
  }

  private obtenerPais(codigoPais: string): PaisDTO
  {
    let paisARetornarDTO: PaisDTO = null;
    for (const paisDTO of this.paisesBackupDTOs)
    {
      if (paisDTO.codigo === codigoPais)
      {
        paisARetornarDTO = paisDTO;
        break;
      }
    }

    return paisARetornarDTO;
  }

  public onTipoDocumentoSelect(): void
  {
    this.receptorCFEDTO.tipoDocumento = this.obtenerTipoDocumento(this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado);

    if (this.datosInicioReceptorDTO.esABM)
    {
      this.datosInicioReceptorDTO.paisesDTOs = this.obtenerPaisesPorTipoDocumento(this.receptorCFEDTO.tipoDocumento);
    }
    else
    {
      this.filtrarReceptoresDisponibles();

      this.parentFormGroup.get('documentoReceptorControl').reset();
      this.parentFormGroup.get('razonSocialReceptorControl').reset();
      this.parentFormGroup.get('direccionReceptorControl').reset();
      this.parentFormGroup.get('ciudadReceptorControl').reset();
      this.parentFormGroup.get('departamentoReceptorControl').reset();
    }

    this.documentoReceptorControl.setValue('');
    this.input();
  }

  private obtenerPaisesPorTipoDocumento(tipoDocumentoDTO: TipoDocumentoDTO): Array<PaisDTO>
  {
    const paisesDTOs: Array<PaisDTO> = new Array<PaisDTO>();
    const paisUyDTO: PaisDTO = this.obtenerPais(COD_PAIS_URU);
    const paisArDTO: PaisDTO = this.obtenerPais(COD_PAIS_ARG);
    const paisUsDTO: PaisDTO = this.obtenerPais(COD_PAIS_US);
    const paisMxDTO: PaisDTO = this.obtenerPais(COD_PAIS_MX);
    const paisBrDTO: PaisDTO = this.obtenerPais(COD_PAIS_BR);
    const paisPeDTO: PaisDTO = this.obtenerPais(COD_PAIS_PE);
    const paisPyDTO: PaisDTO = this.obtenerPais(COD_PAIS_PY);
    const paisClDTO: PaisDTO = this.obtenerPais(COD_PAIS_CL);

    switch (tipoDocumentoDTO.codigo)
    {
      case COD_TIPO_DOC_RUT:
        paisesDTOs.push(paisUyDTO);
        break;
      case COD_TIPO_DOC_CI:
        paisesDTOs.push(paisUyDTO);
        break;
      case COD_TIPO_DOC_OTROS:
        paisesDTOs.push(paisUyDTO);
        paisesDTOs.push(paisArDTO);
        paisesDTOs.push(paisUsDTO);
        paisesDTOs.push(paisMxDTO);
        paisesDTOs.push(paisBrDTO);
        paisesDTOs.push(paisPeDTO);
        paisesDTOs.push(paisPyDTO);
        paisesDTOs.push(paisClDTO);
        break;
      case COD_TIPO_DOC_DNI:
        paisesDTOs.push(paisArDTO);
        break;
      default:
        paisesDTOs.push(paisUyDTO);
        paisesDTOs.push(paisArDTO);
        break;
    }

    return paisesDTOs;
  }

  private obtenerTiposDocumentosPorPais(paisDTO: PaisDTO): Array<TipoDocumentoDTO>
  {
    const tiposDocumentosDTOs: Array<TipoDocumentoDTO> = new Array<TipoDocumentoDTO>();
    const tipoDocumentoRutDTO: TipoDocumentoDTO = this.obtenerTipoDocumento(COD_TIPO_DOC_RUT);
    const tipoDocumentoCiDTO: TipoDocumentoDTO = this.obtenerTipoDocumento(COD_TIPO_DOC_CI);
    const tipoDocumentoOtrosDTO: TipoDocumentoDTO = this.obtenerTipoDocumento(COD_TIPO_DOC_OTROS);
    const tipoDocumentoDniDTO: TipoDocumentoDTO = this.obtenerTipoDocumento(COD_TIPO_DOC_DNI);

    switch (paisDTO.codigo)
    {
      case COD_PAIS_URU:
        tiposDocumentosDTOs.push(tipoDocumentoRutDTO);
        tiposDocumentosDTOs.push(tipoDocumentoCiDTO);
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_ARG:
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        tiposDocumentosDTOs.push(tipoDocumentoDniDTO);
        break;
      case COD_PAIS_BR :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_PY :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_PE :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_US :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_MX :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      case COD_PAIS_CL :
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        break;
      default:
        tiposDocumentosDTOs.push(tipoDocumentoRutDTO);
        tiposDocumentosDTOs.push(tipoDocumentoCiDTO);
        tiposDocumentosDTOs.push(tipoDocumentoOtrosDTO);
        tiposDocumentosDTOs.push(tipoDocumentoDniDTO);
        break;
    }

    return tiposDocumentosDTOs;
  }

  public onDocumentoSelect(event): void
  {
    const receptorCFESeleccionadoDTO: ReceptorCFEDTO = Object.assign(new ReceptorCFEDTO(), this.obtenerReceptorPorDocumento(event));

    this.receptorCFEDTO.codigo = receptorCFESeleccionadoDTO.codigo;
    this.receptorCFEDTO.tipoDocumento = receptorCFESeleccionadoDTO.tipoDocumento;
    this.receptorCFEDTO.pais = receptorCFESeleccionadoDTO.pais;
    this.receptorCFEDTO.documento = receptorCFESeleccionadoDTO.documento;
    this.receptorCFEDTO.razonSocial = receptorCFESeleccionadoDTO.razonSocial;
    this.receptorCFEDTO.direccion = receptorCFESeleccionadoDTO.direccion;
    this.receptorCFEDTO.ciudad = receptorCFESeleccionadoDTO.ciudad;
    this.receptorCFEDTO.departamento = receptorCFESeleccionadoDTO.departamento;
    this.receptorCFEDTO.estaUsadoEnCFE = receptorCFESeleccionadoDTO.estaUsadoEnCFE;
    this.receptorCFEDTO.tienePadre = receptorCFESeleccionadoDTO.tienePadre;

    this.datosInicioReceptorDTO.codigoPaisSeleccionado = receptorCFESeleccionadoDTO.pais.codigo;
    this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado = receptorCFESeleccionadoDTO.tipoDocumento.codigo;
    this.razonSocialReceptorControl.setValue(receptorCFESeleccionadoDTO.razonSocial);
  }

  public onRazonSocialSelect(event): void
  {
    const receptorCFESeleccionadoDTO: ReceptorCFEDTO = Object.assign(new ReceptorCFEDTO(), this.obtenerReceptorPorRazonSocial(event));

    this.receptorCFEDTO.codigo = receptorCFESeleccionadoDTO.codigo;
    this.receptorCFEDTO.tipoDocumento = receptorCFESeleccionadoDTO.tipoDocumento;
    this.receptorCFEDTO.pais = receptorCFESeleccionadoDTO.pais;
    this.receptorCFEDTO.documento = receptorCFESeleccionadoDTO.documento;
    this.receptorCFEDTO.razonSocial = receptorCFESeleccionadoDTO.razonSocial;
    this.receptorCFEDTO.direccion = receptorCFESeleccionadoDTO.direccion;
    this.receptorCFEDTO.ciudad = receptorCFESeleccionadoDTO.ciudad;
    this.receptorCFEDTO.departamento = receptorCFESeleccionadoDTO.departamento;
    this.receptorCFEDTO.estaUsadoEnCFE = receptorCFESeleccionadoDTO.estaUsadoEnCFE;
    this.receptorCFEDTO.tienePadre = receptorCFESeleccionadoDTO.tienePadre;

    this.datosInicioReceptorDTO.codigoPaisSeleccionado = receptorCFESeleccionadoDTO.pais.codigo;
    this.datosInicioReceptorDTO.codigoTipoDocumentoSeleccionado = receptorCFESeleccionadoDTO.tipoDocumento.codigo;
    this.documentoReceptorControl.setValue(receptorCFESeleccionadoDTO.documento);
  }

  public onPaisSelect(): void
  {
    this.receptorCFEDTO.pais = this.obtenerPais(this.datosInicioReceptorDTO.codigoPaisSeleccionado);

    if (this.datosInicioReceptorDTO.esABM)
    {
      this.datosInicioReceptorDTO.tiposDocumentosDTOs = this.obtenerTiposDocumentosPorPais(this.receptorCFEDTO.pais);
    }
    else
    {
      this.filtrarReceptoresDisponibles();

      this.parentFormGroup.get('documentoReceptorControl').reset();
      this.parentFormGroup.get('razonSocialReceptorControl').reset();
      this.parentFormGroup.get('direccionReceptorControl').reset();
      this.parentFormGroup.get('ciudadReceptorControl').reset();
      this.parentFormGroup.get('departamentoReceptorControl').reset();
    }

    this.input();
  }

  private filtrarReceptoresDisponibles(): void
  {
    if (this.datosInicioReceptorDTO.receptoresCFEDTOsDisponiblesCopia.length === 0)
    {
      this.datosInicioReceptorDTO.receptoresCFEDTOsDisponiblesCopia = this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs.map(x => Object.assign({}, x));
    }

    let receptoresCFEDTOsDisponibles = this.datosInicioReceptorDTO.receptoresCFEDTOsDisponiblesCopia.map(x => Object.assign({}, x));
    const codigoTipoDocumento = Utils.isNotNullOrUndefined(this.receptorCFEDTO.tipoDocumento) ? this.receptorCFEDTO.tipoDocumento.codigo : null;
    const codigoPais = Utils.isNotNullOrUndefined(this.receptorCFEDTO.pais) ? this.receptorCFEDTO.pais.codigo : null;

    receptoresCFEDTOsDisponibles = receptoresCFEDTOsDisponibles.filter((receptor) =>
    {
      const validacionPais = (Utils.isNotNullOrUndefined(codigoPais)) ? receptor.pais.codigo === codigoPais : true;
      const validacionTipoDocumento = (Utils.isNotNullOrUndefined(codigoTipoDocumento)) ? receptor.tipoDocumento.codigo === codigoTipoDocumento : true;

      return validacionPais && validacionTipoDocumento ? receptor : null;
    });

    this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs = receptoresCFEDTOsDisponibles;
  }

  private obtenerReceptorPorDocumento(documento: string): ReceptorCFEDTO
  {
    const receptoresCFEsDisponiblesDTOs: Array<ReceptorCFEDTO> = this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs;

    return receptoresCFEsDisponiblesDTOs.find((receptor) =>
    {
      return documento === receptor.documento;
    });
  }

  private obtenerReceptorPorRazonSocial(razonSocial: string): ReceptorCFEDTO
  {
    const receptoresCFEDTOsDisponibles: Array<ReceptorCFEDTO> = this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs;

    return receptoresCFEDTOsDisponibles.find((receptor) =>
    {
      return razonSocial === receptor.razonSocial;
    });
  }

  public tipoDocumentoDisabled(): boolean
  {
    return (!this.datosInicioReceptorDTO.esABM) || (this.datosInicioReceptorDTO.esABM && (this.receptorCFEDTO.estaUsadoEnCFE || this.receptorCFEDTO.tienePadre));
  }

  public paisDisabled(): boolean
  {
    return (!this.datosInicioReceptorDTO.esABM) || (this.datosInicioReceptorDTO.esABM && (this.receptorCFEDTO.estaUsadoEnCFE || this.receptorCFEDTO.tienePadre));
  }

  clean_ci(ci: string): string {
  return ci.replace(/\D/g, '');
  }

  functionCedula(ci: string): boolean {
    const cleaned_ci = this.clean_ci(ci);
    if (cleaned_ci.length < 6 || cleaned_ci.length > 8) {
      return false;
    }

    const arrCoefs = [2, 9, 8, 7, 6, 3, 4, 1];
    const difCoef = arrCoefs.length - cleaned_ci.length;
    let suma = 0;

    for (let i = cleaned_ci.length - 1; i > -1; i--) {
      const dig = cleaned_ci.substring(i, i + 1);
      const digInt = parseInt(dig, 10);
      const coef = arrCoefs[i + difCoef];
      suma = suma + digInt * coef;
    }

    return (suma % 10) === 0;
  }

  formatIdentificadorCompra() {
    this.receptorCFEDTO.identificadorCompra = this.parentFormGroup.get('identificadorCompraControl').value.replace(/[^a-zA-Z0-9.-]/g, '').slice(0, 50);
    this.parentFormGroup.get('identificadorCompraControl').setValue(this.receptorCFEDTO.identificadorCompra);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs
      .map(receptor => receptor.documento)
      .filter(option => option.toLowerCase().includes(filterValue))
      .sort();
  }

  private _filterRazonesSociales(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.datosInicioReceptorDTO.receptoresCFEsDisponiblesDTOs
      .map(receptor => receptor.razonSocial)
      .filter(razonSocial => razonSocial.toLowerCase().includes(filterValue))
      .sort();
  }

  limpiarAutocompletes() {
    this.documentoReceptorControl.setValue('');
    this.documentoReceptorControl.markAsUntouched();
    this.razonSocialReceptorControl.setValue('');
    this.razonSocialReceptorControl.markAsUntouched();
  }

  procesarEntrada(event: Event) {
    const inputElement = event.target as HTMLInputElement;
    this.receptorCFEDTO.documento = inputElement.value.replace(/[^a-zA-Z0-9]/g, '');
    this.documentoReceptorControl.setValue(this.receptorCFEDTO.documento);
  }
}
